import React from 'react';
import { mergeTests } from '../../../ui-toolkit/test-utilities/mergeTests';
import classNames from 'classnames';
import { IParentComponent } from '../../interfaces/IParentComponent';

export const StackTraceTW: React.FC<IParentComponent<HTMLElement>> = ({ children, className, ...rest }) => {
  return (
    <code
      className={classNames('block whitespace-pre-line break-words text-left', className)}
      data-test-id={mergeTests(rest['data-test-id'], 'stack-trace')}
      data-test-class={mergeTests(rest['data-test-class'], 'stack-trace')}
      {...rest}
    >
      {children}
    </code>
  );
};
